import(/* webpackMode: "eager" */ "/app/apps/web/src/app/match/game/page.tsx");
